import { Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../../core';
import { QuestionBase, DynamicFormComponent } from '../../../core/components/forms';
import { Client, Plan } from 'core/models';
import { PlansService } from 'core/services/plans.service';
import { SubscriptionQuestionService } from '../../questions-services/subscription-questions.service';
import { NO_EDITOR_PLAN_BASE, NO_EDITOR_PLAN } from '../../assets/constants';

@Component({
  selector: 'lms-client-plan-editor',
  templateUrl: './client-plan-editor.component.html',
  providers: [SubscriptionQuestionService]
})
export class ClientPlanEditorComponent implements OnInit {
  @Input() client: Client;
  @Output() onSave = new EventEmitter<Plan>();
  @ViewChild('modalPlanForm', { static: false }) public modalComponent: ModalComponent;
  @ViewChild('dynamicForm', { static: false }) public dynamicForm: DynamicFormComponent;
  @Output() public formErrorEmit: EventEmitter<object> = new EventEmitter<object>();

  public questions: QuestionBase<any>[];
  public payLoad = '';

  constructor(private plansService: PlansService, private subscriptionQuestionsService: SubscriptionQuestionService) {}

  ngOnInit() {}

  private setQuestions(): void {
    this.questions = this.subscriptionQuestionsService.getPlanQuestions(this.client.plan, this.client);
  }

  public openModal(): void {
    this.setQuestions();
    this.modalComponent.open();
  }

  public onCancel(): void {
    this.modalComponent.close();
  }

  public onSubmit(plan: Plan): void {
    const planData = { ...plan, editorAccess: plan.type !== NO_EDITOR_PLAN };
    if (this.client.plan.editorAccess) {
      if (!planData.editorAccess) {
        this.delete();
      } else {
        this.onUpdate(planData);
      }
    } else {
      this.onUpdate(planData);
    }
    this.modalComponent.close();
  }

  private onUpdate(planData: Object): void {
    this.plansService
      .updateClientPlan(this.client.id, { ...planData, scope: 'corporate' })
      .then((updatedPlan: Plan) => {
        this.endSubmit(null);
        this.onSave.emit(updatedPlan);
      })
      .catch((err) => {
        this.formErrorEmit.emit(err);
        this.endSubmit(err);
      });
  }

  private delete(): void {
    this.plansService
      .deleteClientPlan(this.client.id)
      .then(() => {
        this.endSubmit(null);
        this.onSave.emit(NO_EDITOR_PLAN_BASE);
      })
      .catch((err) => {
        this.formErrorEmit.emit(err);
        this.endSubmit(err);
      });
  }

  private endSubmit(value): void {
    this.dynamicForm.submitted(value);
  }
}
